(function($, App, Utils, Components){
  'use strict';

  var logger = new Logger("Accordion Text");

  Components.create('AccordionText', {

    Selectors: {
      Container: '.a-container',
      Button: '.a-btn'
    },

    Classes: {
      Active: 'active'
    },

    bindEvents: function() {
      const $Container = $(this.Selectors.Container);
      const _this = this;
      $('.a-btn').on('click', function () {
        let $thisContainer = $(this).closest(_this.Selectors.Container);
        /*if (!$thisContainer.hasClass(_this.Classes.Active)) {
          $Container.removeClass('active');
        }*/
        $thisContainer.toggleClass(_this.Classes.Active)
      });

    },

    init: function() {
      this.bindEvents();
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);